module.exports = __webpack_public_path__ + "static/media/west_mediterranean.55116c81.png";